import {
    CUSTOMER_YEAR_FILTER,
    CUSTOMER_QTR_FILTER,
    CUSTOMER_MONTH_FILTER,
    CUSTOMER_GROUP_SELECT,
    CUSTOMER_PROVINCE_SELECT,
    CUSTOMER_MARKETPLACE_SELECT,
    CUSTOMER_GROUPTABLE_SELECT,
    CUSTOMER_SALE_PROD_CARD,
    CUSTOMER_SALE_PROD,
    CUSTOMER_SALE_PROD_MONTH,
    CUSTOMER_NEWCUS_CARD,
    CUSTOMER_NEWCUS_CHART,
    CUSTOMER_ACTIVE_CARD,
    CUSTOMER_ACTIVE_CHART,
    CUSTOMER_AGING_CARD,
    CUSTOMER_AGING_CHART,
    CUSTOMER_GROUP_FILTER,
    CUSTOMER_CODE_FILTER,
    NEW_CUSTOMER_FILTER,
    CUSTOMER_PROVINCE_FILTER,
    CUSTOMER_MARKETPLACE_FILTER,
    CUSTOMER_TYPE_FILTER,
    CUSTOMER_FORMATDISPLAY_FILTER,
    CUSTOMER_LIST_KEYWORD_FILTER,
    SalesFocus_Invoice_CHART,
    CUSTOMER_SEARCH_TRIGGER
} from '../constants/ActionTypes';
import { quarterData, monthData, monthDataLLG, monthDataSSP } from '../utils/DateObject';

let dt = new Date();
let year = dt.getFullYear()
let month = dt.getMonth()+1;

// let monthLLG = dt.getMonth()+2;

// let currentYear = {value: year, label: year};
// let currentMonth = monthData.find( m => m.value === month);
// let currentQuarter = quarterData.find( q => q.value === Math.ceil(month/3))

// let currentMonthLLG = monthDataLLG.find( m => m.value === monthLLG);

// let authUser = JSON.parse(localStorage.getItem("authUser"));

// const initialState = {
//     yearSelected: currentYear,
//     qtrSelected: currentQuarter,
//     monthSelected: authUser && authUser.calendarType == "LLG" ? currentMonthLLG : currentMonth,
    let authUser = JSON.parse(localStorage.getItem("authUser"));
    let calendarType = authUser?.calendarType || 'NOR';

    // คำนวณ month sequence ตาม calendar type
    let currentSeq = month;
    if (calendarType === 'SSP') {
        currentSeq = month >= 10 ? month - 9 : month + 3;
    } else if (calendarType === 'LLG') {
        currentSeq = month === 12 ? 1 : month + 1;
    }

    // คำนวณ quarter จาก sequence
    let currentQtrValue = Math.ceil(currentSeq / 3);

    let currentYear = {value: year, label: year};
    // ใช้ month data ตาม calendar type เพื่อให้ label ถูกต้อง
    let monthLookup = calendarType === 'SSP' ? monthDataSSP 
        : calendarType === 'LLG' ? monthDataLLG 
        : monthData;
    let currentMonth = monthLookup.find(m => m.value === currentSeq);
    let currentQuarter = quarterData.find(q => q.value === currentQtrValue);

const initialState = {
    yearSelected: currentYear,
    qtrSelected: currentQuarter,
    monthSelected: currentMonth,
    cusGroupSelected: "",
    cusProvinceSelected: "",
    cusMarketPlaceSelected: "",
    cusGroupTableSelected: "customergroup",
    cusSaleProdCardSelected: "",
    cusSaleProdSelected: "",
    cusSaleProdMonthSelected: new Date().getMonth()+1,
    cusNewCusCardSelected: "",
    cusNewCusChartSelected: "",
    cusActiveCardSelected: "",
    cusActiveChartSelected: "",
    cusAgingCardSelected: true,
    cusAgingChartSelected: "Chart3",
    customerGroupSelected: "",
    customerCodeSelected: "",
    newCustomerSelected: "",
    customerProvinceSelected: "",
    customerMarketPlaceSelected: "",
    customerTypeSelected: null,
    customerDisplaySelected: {value: 'compare', label: 'ISA_Display_Compare'},  // Translate key - resolved in components
    customerListKeyword: "",
    salesInvoiceChartSelected: "",
    searchTrigger: 1  // เริ่มต้นที่ 1 เพื่อดึงข้อมูลครั้งแรก
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CUSTOMER_YEAR_FILTER:
            return {
                ...state,
                yearSelected: action.payload,
            }
        case CUSTOMER_QTR_FILTER:
            return {
                ...state,
                qtrSelected: action.payload,
            }
        case CUSTOMER_MONTH_FILTER:
            return {
                ...state,
                monthSelected: action.payload,
            }
        case CUSTOMER_GROUP_SELECT:
            return {
                ...state,
                cusGroupSelected: action.payload
            }
        case CUSTOMER_PROVINCE_SELECT:
            return {
                ...state,
                cusProvinceSelected: action.payload
            }
        case CUSTOMER_MARKETPLACE_SELECT:
            return {
                ...state,
                cusMarketPlaceSelected: action.payload
            }
        case CUSTOMER_GROUPTABLE_SELECT:
            return {
                ...state,
                cusGroupTableSelected: action.payload
            }    
        case CUSTOMER_SALE_PROD_CARD:
            return {
                ...state,
                cusSaleProdCardSelected: action.payload
            }
        case CUSTOMER_SALE_PROD:
            return {
                ...state,
                cusSaleProdSelected: action.payload
            }
        case CUSTOMER_SALE_PROD_MONTH:
            return {
                ...state,
                cusSaleProdMonthSelected: action.payload
            }
        case CUSTOMER_NEWCUS_CARD:
            return {
                ...state,
                cusNewCusCardSelected: action.payload
            }
        case CUSTOMER_NEWCUS_CHART:
            return {
                ...state,
                cusNewCusChartSelected: action.payload
            }
        case CUSTOMER_ACTIVE_CARD:
            return {
                ...state,
                cusActiveCardSelected: action.payload
            }
        case CUSTOMER_ACTIVE_CHART:
            return {
                ...state,
                cusActiveChartSelected: action.payload
            }
        case CUSTOMER_AGING_CARD:
            return {
                ...state,
                cusAgingCardSelected: action.payload
            }
        case CUSTOMER_AGING_CHART:
            return {
                ...state,
                cusAgingChartSelected: action.payload
            }
        case CUSTOMER_GROUP_FILTER:
            return {
                ...state,
                customerGroupSelected: action.payload
            }
        case CUSTOMER_CODE_FILTER:
            return {
                ...state,
                customerCodeSelected: action.payload
            }
        case NEW_CUSTOMER_FILTER:
            return {
                ...state,
                newCustomerSelected: action.payload
            }
        case CUSTOMER_PROVINCE_FILTER:
            return {
                ...state,
                customerProvinceSelected: action.payload
            }
        case CUSTOMER_MARKETPLACE_FILTER:
            return {
                ...state,
                customerMarketPlaceSelected: action.payload
            }
        case CUSTOMER_TYPE_FILTER:
            return {
                ...state,
                customerTypeSelected: action.payload
            }   
        case CUSTOMER_FORMATDISPLAY_FILTER:
            return {
                ...state,
                customerDisplaySelected: action.payload
            }
        case CUSTOMER_LIST_KEYWORD_FILTER:
            return {
                ...state,
                customerListKeyword: action.payload
            }
        case SalesFocus_Invoice_CHART:
            return {
            ...state,
            salesInvoiceChartSelected: action.payload
            }
        case CUSTOMER_SEARCH_TRIGGER:
            return {
                ...state,
                searchTrigger: action.payload
            }
        default:
            return state;
    }
}